<div class="flex flex-col gap-5 w-full">
  <proffeo-company-groups-company-node
    [companyGroup]="companyGroup()"
  ></proffeo-company-groups-company-node>
</div>
